module.exports = __webpack_public_path__ + "static/media/S (51).c9e1984c.jpg";